import { render, staticRenderFns } from "./VxTd.vue?vue&type=template&id=2a676092"
import script from "./VxTd.vue?vue&type=script&lang=js"
export * from "./VxTd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports